import {
  useEffect,
  memo,
  useState,
  useRef,
} from 'react';
import PropTypes from 'prop-types';
import { Form } from 'formsy-semantic-ui-react';
import { Label } from 'semantic-ui-react';
import ResendSMSCode from './ResendCode';
import { useTranslation } from 'next-i18next';
import styles from './sms-check-fields.module.scss';
import UINotifications from 'components/UI/Notifications';
import { errorMessagesToStrings } from "helpers/helpers";
import { useRouter } from "next/router";

import LockOutlinedIcon from '@material-ui/icons/LockOutlined';

const label = <Label color="red" pointing />;

const SMSCodeFields = ({
  loading, fieldName, autoFocus, scope, smsCode, phone, getSMSCode, reset, onLoading, onNotExistUserError, captcha,
  onChangeCodeScope, codeScope
}) => {
  const { t } = useTranslation('common');
  const router = useRouter();
  const [visibleCodeInput, setVisibleCodeInput] = useState(false);
  const instanceTimeoutRef = useRef(null);
  //TODO исправлено на звонок
  useEffect(() => {
    onLoading(true)
    getSMSCode(phone, scope, captcha, 'sms').then(() => {
      setVisibleCodeInput(true);
      onLoading(false)
      if (autoFocus) {
        instanceTimeoutRef.current = setTimeout(() => {
          document.getElementById(`${fieldName}_input`).focus();
        }, 300);
      }
    }).catch((err) => {
      if (scope === "REGISTER_GARAGE" && err.data[0]?.type === 'codeActorAlreadyExistsBusinessProblem') {
        UINotifications.show({
          type: 'info',
          html: t('signUpForm.errors.actorAlreadyExists')
        });
        router.push({ pathname: '/access', query: { tab: 'auth', phone } })
      } else if (scope === "AUTHENTICATE_EMPLOYEE" && err.data && err.data[0]?.type === 'codeActorNotExistsBusinessProblem') {
        onNotExistUserError();
        UINotifications.show({
          type: 'danger',
          html: errorMessagesToStrings(err.data),
          actions: [{
            label: t('auth.signUp'),
            primary: true,
            onClick: (e, actions) => {
              router.push({ pathname: `/access`, query: { tab: 'signup', phone } });
              actions.destroy();
            }
          }]
        });
      } else {
        UINotifications.show({
          type: 'danger',
          html: errorMessagesToStrings(err.data)
        });
      }
    });

    return () => {
      reset();
      clearTimeout(instanceTimeoutRef.current)
    };
  }, []);

  return (
    <div className={styles.root}>

      <If condition={visibleCodeInput}>
        <Form.Input
          className="hidden-input"
          type="hidden"
          name={`${fieldName}[uuid]`}
          value={smsCode.data.uuid}
        />

        <Form.Input
          id={`${fieldName}_input`}
          required
          className="new-design no-label sms-code-input"
          iconPosition="left"
          autoComplete="one-time-code"
          autoFocus={autoFocus}
          inputMode="numeric"
          pattern="[0-9]*"
          name={`${fieldName}[code]`}
          placeholder={codeScope === 'call' ? t('auth.code') : 'Код из смс'}
          maxLength={4}
          loading={loading || smsCode.loading}
          validations={{ isLength: 4 }}
          validationErrors={{
            isDefaultRequiredValue: t('formErrors.required'),
            isLength: t('formErrors.numLength', { count: 4 }),
          }}
          errorLabel={label}
        >
          <LockOutlinedIcon />
          <input />
        </Form.Input>

        <ResendSMSCode
          onReCall={() => {
            onChangeCodeScope('call')
            return getSMSCode(phone, scope, captcha, 'call')
          }}
          onResendSms={() => {
            onChangeCodeScope('sms')
            return getSMSCode(phone, scope, captcha, 'sms')
          }}
        />
      </If>
    </div>
  )
};

SMSCodeFields.propTypes = {
  phone: PropTypes.string,
  fieldName: PropTypes.string,
  data: PropTypes.object,
  loading: PropTypes.bool,
  scope: PropTypes.string.isRequired,

  // From container.js
  smsCode: PropTypes.object.isRequired,
  getSMSCode: PropTypes.func.isRequired,
  reset: PropTypes.func.isRequired
};

SMSCodeFields.defaultProps = {
  phone: '',
  fieldName: 'verificationCode',
  loading: false,
  autoFocus: false
};

export default memo(SMSCodeFields);